export default __webpack_public_path__ + "static/media/Trend3.65f9a616.svg";